// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Nn1m","content":"LoadingAlert_content__12yhM"};